import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "redirect-overlay-container" }
const _hoisted_6 = { class: "redirect-overlay" }
const _hoisted_7 = ["data-seconds"]
const _hoisted_8 = { class: "buttons-container" }
const _hoisted_9 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { "aria-label": "breadcrumb" }
const _hoisted_14 = { class: "breadcrumb" }
const _hoisted_15 = { class: "breadcrumb-item" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "breadcrumb-item" }
const _hoisted_18 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_19 = {
  id: "main",
  class: ""
}
const _hoisted_20 = { class: "container px-xs-0 pt-2 pt-sm-2 pt-md-0" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "row mx-0 beratung" }
const _hoisted_26 = { class: "col-12 col-headline beratung-headline bg-white text-break" }
const _hoisted_27 = { class: "buttons-container float-end" }
const _hoisted_28 = { class: "col-12 col-md-5 col-lg-3 mb-3 mt-3 mt-md-0 bg-white beratung-sidebar" }
const _hoisted_29 = {
  key: 0,
  class: "beratung-sidebar-block"
}
const _hoisted_30 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_31 = { class: "mb-0" }
const _hoisted_32 = {
  key: 1,
  class: "mb-1 d-block"
}
const _hoisted_33 = {
  key: 1,
  class: "beratung-sidebar-block"
}
const _hoisted_34 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = { class: "block-text" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { class: "beratung-sidebar-block" }
const _hoisted_43 = { class: "beratung-sidebar-block-kontakt" }
const _hoisted_44 = ["href", "title"]
const _hoisted_45 = {
  key: 1,
  class: "block-head d-flex align-items-center"
}
const _hoisted_46 = ["href", "title"]
const _hoisted_47 = {
  key: 2,
  class: "block-head d-flex align-items-center"
}
const _hoisted_48 = ["href", "title"]
const _hoisted_49 = {
  key: 3,
  class: "block-head d-flex align-items-center"
}
const _hoisted_50 = ["href", "title"]
const _hoisted_51 = {
  key: 2,
  class: "beratung-sidebar-block"
}
const _hoisted_52 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_53 = { class: "mb-0" }
const _hoisted_54 = { class: "block-text oz-list" }
const _hoisted_55 = {
  key: 3,
  class: "beratung-sidebar-block"
}
const _hoisted_56 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_57 = { class: "mb-0" }
const _hoisted_58 = { class: "block-text" }
const _hoisted_59 = {
  key: 4,
  class: "beratung-sidebar-block"
}
const _hoisted_60 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_61 = { class: "mb-0" }
const _hoisted_62 = { class: "block-text" }
const _hoisted_63 = { class: "col-12 col-md-7 col-lg-6 mb-3 bg-white beratung-content" }
const _hoisted_64 = {
  key: 0,
  lang: "de",
  class: "beratung-content-block"
}
const _hoisted_65 = {
  key: 1,
  lang: "de",
  class: "beratung-content-block"
}
const _hoisted_66 = {
  key: 2,
  lang: "de",
  class: "beratung-content-block"
}
const _hoisted_67 = {
  key: 3,
  lang: "de",
  class: "beratung-content-block"
}
const _hoisted_68 = { class: "btn termin-link w-100 p-3 text-start" }
const _hoisted_69 = { class: "col-12 col-md-12 col-lg-3 mb-3 mt-md-0 bg-white beratung-sidebar" }
const _hoisted_70 = {
  key: 0,
  class: "beratung-sidebar-block sidebar-right"
}
const _hoisted_71 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_72 = { class: "mb-0" }
const _hoisted_73 = { class: "block-text" }
const _hoisted_74 = {
  key: 1,
  class: "beratung-sidebar-block sidebar-right"
}
const _hoisted_75 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_76 = { class: "mb-0" }
const _hoisted_77 = { class: "block-text" }
const _hoisted_78 = {
  key: 2,
  class: "beratung-sidebar-block sidebar-right"
}
const _hoisted_79 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_80 = { class: "mb-0" }
const _hoisted_81 = { class: "block-text" }
const _hoisted_82 = {
  key: 3,
  class: "beratung-sidebar-block sidebar-right"
}
const _hoisted_83 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_84 = { class: "mb-0" }
const _hoisted_85 = { class: "block-text sidebar-tag-box" }
const _hoisted_86 = { class: "list-unstyled" }
const _hoisted_87 = { class: "tag" }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = {
  id: "main",
  class: ""
}
const _hoisted_90 = { class: "container px-xs-0" }
const _hoisted_91 = { class: "row mx-0 beratung" }
const _hoisted_92 = { class: "col-12 col-headline bg-white border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_loading_container, {
    state: _ctx.state,
    i18nErrorMessage: "views.legalEntities.errorMessage"
  }, {
    default: _withCtx(() => [
      (!_ctx.notFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.showOverlay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('detailviews.redirectNote')) + " " + _toDisplayString(_ctx.getDomain()), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('detailviews.redirectNotice1')) + " ", 1),
                            _createElementVNode("strong", {
                              id: "redirect-counter-color",
                              class: "redirect-counter-color",
                              "data-seconds": _ctx.$t('detailviews.redirectSeconds')
                            }, "3 " + _toDisplayString(_ctx.$t('detailviews.redirectSeconds')), 9, _hoisted_7),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('detailviews.redirectNotice2')), 1)
                          ]),
                          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("a", {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToExternalLink(_ctx.cCenter, _ctx.tempCounselingSystem))),
                              class: "btn btn-redirect-custom"
                            }, _toDisplayString(_ctx.$t('detailviews.redirectButton')), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("nav", _hoisted_13, [
                      _createElementVNode("ol", _hoisted_14, [
                        _createElementVNode("li", _hoisted_15, [
                          _createElementVNode("a", { href: _ctx.langMain }, _toDisplayString(_ctx.$t('detailviews.home')), 9, _hoisted_16)
                        ]),
                        _createElementVNode("li", _hoisted_17, [
                          _createVNode(_component_router_link, { to: '/' }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('detailviews.counselingCenters')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_18, _toDisplayString(_ctx.cCenter.name), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("main", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.routerbacklink === 'y' && _ctx.routerbacklinkCC !== 'y')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          role: "button",
                          class: "btn btn-link btn-back",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
                          title: _ctx.$t('detailviews.backLink')
                        }, _toDisplayString(_ctx.$t('detailviews.backLink')), 9, _hoisted_23))
                      : _createCommentVNode("", true),
                    ((_ctx.routerbacklink === 'y' && _ctx.routerbacklinkCC === 'y'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          role: "button",
                          class: "btn btn-link btn-back",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToSearch2())),
                          title: _ctx.$t('detailviews.backLink')
                        }, _toDisplayString(_ctx.$t('detailviews.backLink')), 9, _hoisted_24))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.cCenter.name), 1),
                    _createElementVNode("div", _hoisted_27, [
                      (_ctx.cCenter.chatCounselingSystem && _ctx.cCenter.chatCounselingSystem !== 'NONE')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-counseling-custom",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCounselingUrl(_ctx.cCenter, 'CHAT')))
                          }, [
                            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "icon onb-contact--chat" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('views.counselingCenters.chatConsult')), 1),
                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "icon onb-contact--chat-link" }, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cCenter.videoCounselingSystem && _ctx.cCenter.videoCounselingSystem !== 'NONE')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "btn btn-counseling-custom",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCounselingUrl(_ctx.cCenter, 'VIDEO')))
                          }, [
                            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "icon onb-contact--video" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('views.counselingCenters.videoConsult')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cCenter.mailCounselingSystem && _ctx.cCenter.mailCounselingSystem !== 'NONE')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "btn btn-counseling-custom",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openCounselingUrl(_ctx.cCenter, 'MAIL')))
                          }, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "icon onb-contact--mail" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('views.counselingCenters.mailConsult')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    (_ctx.cCenter.legalEntities && _ctx.cCenter.legalEntities.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _cache[12] || (_cache[12] = _createElementVNode("div", {
                              class: "icon svg-legalEntity",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.$t('detailviews.legalEntities')) + ":", 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cCenter.legalEntities, (rt, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "block-text",
                              key: index
                            }, [
                              (!_ctx.isFrauen)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "mb-1 d-block",
                                    to: {
                  name: 'legal-entities',
                  params: { leid: rt.id, ccid: _ctx.cCenter.id, backlink: _ctx.routerbacklink, backlinkCC: 'y', backUrlHistory: _ctx.backUrlHistory}
                },
                                    title: _ctx.$t('detailviews.openLeLink')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(rt.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "title"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(rt.name), 1))
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cCenter.address && (_ctx.cCenter.address.streetName || _ctx.cCenter.address.houseNumber || _ctx.cCenter.address.addressSupplement || _ctx.cCenter.address.zipCode || _ctx.cCenter.address.city))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _cache[13] || (_cache[13] = _createElementVNode("div", {
                              class: "icon svg-adresse",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("h2", _hoisted_35, _toDisplayString(_ctx.$t('detailviews.address')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("p", null, [
                              (_ctx.cCenter.address && _ctx.cCenter.address.streetName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.cCenter.address.streetName), 1))
                                : _createCommentVNode("", true),
                              (_ctx.cCenter.address && _ctx.cCenter.address.houseNumber)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " " + _toDisplayString(_ctx.cCenter.address.houseNumber), 1))
                                : _createCommentVNode("", true),
                              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                              (_ctx.cCenter.address && _ctx.cCenter.address.addressSupplement)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                    _createTextVNode(_toDisplayString(_ctx.cCenter.address.addressSupplement) + " ", 1),
                                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.cCenter.address && _ctx.cCenter.address.zipCode)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.cCenter.address.zipCode), 1))
                                : _createCommentVNode("", true),
                              _cache[16] || (_cache[16] = _createTextVNode()),
                              (_ctx.cCenter.address && _ctx.cCenter.address.city)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, " " + _toDisplayString(_ctx.cCenter.address.city), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        (_ctx.cCenter.phone && _ctx.cCenter.phone.length > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["block-head d-flex align-items-center", _ctx.cCenter.phone2 ? 'mb-1': ''])
                            }, [
                              _cache[17] || (_cache[17] = _createElementVNode("div", {
                                class: "icon svg-tel",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                href: _ctx.formattedPhoneHref(_ctx.cCenter.phone),
                                title: _ctx.$t('detailviews.telLinkTitle'),
                                class: "h3link"
                              }, _toDisplayString(_ctx.cCenter.phone), 9, _hoisted_44)
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.cCenter.phone2 && _ctx.cCenter.phone2.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _cache[18] || (_cache[18] = _createElementVNode("div", {
                                class: "icon svg-tel invisible",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                href: _ctx.formattedPhoneHref(_ctx.cCenter.phone2),
                                title: _ctx.$t('detailviews.telLinkTitle'),
                                class: "h3link"
                              }, _toDisplayString(_ctx.cCenter.phone2), 9, _hoisted_46)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.cCenter.email && _ctx.cCenter.email.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _cache[19] || (_cache[19] = _createElementVNode("div", {
                                class: "icon svg-email",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                rel: "noopener",
                                href: _ctx.formattedEmailHref(_ctx.cCenter.email),
                                title: _ctx.$t('detailviews.mailLinkTitle'),
                                class: "h3link"
                              }, _toDisplayString(_ctx.$t('detailviews.sendMail')), 9, _hoisted_48)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.cCenter.homepage && _ctx.cCenter.homepage.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _cache[20] || (_cache[20] = _createElementVNode("div", {
                                class: "icon svg-www",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                href: _ctx.formattedUrlHref(_ctx.cCenter.homepage),
                                title: _ctx.$t('detailviews.urlLinkTitle'),
                                class: "h3link extern",
                                rel: "noopener nofollow",
                                target: "_blank"
                              }, _toDisplayString(_ctx.$t('detailviews.goToUrl')), 9, _hoisted_50)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.cCenter.openingHours && _ctx.cCenter.openingHours.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _cache[21] || (_cache[21] = _createElementVNode("div", {
                              class: "icon svg-oeffnungszeiten",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("h2", _hoisted_53, _toDisplayString(_ctx.openHoursHeadline) + ":", 1)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_54, null, 512), [
                            [_directive_dompurify_html, _ctx.groupOpeningHours]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getAvaLang.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", {
                              class: "icon svg-sprachen",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("h2", _hoisted_57, _toDisplayString(_ctx.$t('detailviews.moreLangs')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvaLang, (lang, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(lang.description), 1))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getAvaOffer.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", {
                              class: "icon svg-zusatz",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("h2", _hoisted_61, _toDisplayString(_ctx.$t('detailviews.moreOffers')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvaOffer, (offer, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(offer.description), 1))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    (_ctx.cCenter.information && _ctx.cCenter.information.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('detailviews.information')), 1),
                          _withDirectives(_createElementVNode("div", null, null, 512), [
                            [_directive_dompurify_html, _ctx.cCenter.information]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cCenter.description && _ctx.cCenter.description.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('detailviews.description')), 1),
                          _withDirectives(_createElementVNode("div", null, null, 512), [
                            [_directive_dompurify_html, _ctx.cCenter.description]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cCenter.aboutUs && _ctx.cCenter.aboutUs.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('detailviews.aboutUs')), 1),
                          _withDirectives(_createElementVNode("div", null, null, 512), [
                            [_directive_dompurify_html, _ctx.cCenter.aboutUs]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cCenter.appointmentInfo && _ctx.cCenter.appointmentInfo.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _withDirectives(_createElementVNode("div", _hoisted_68, null, 512), [
                            [_directive_dompurify_html, _ctx.cCenter.appointmentInfo]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    (_ctx.getAvaCtype.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("h2", _hoisted_72, _toDisplayString(_ctx.$t('detailviews.counselingType')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvaCtype, (ctype, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(ctype.description), 1))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getAvaSetting.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("h2", _hoisted_76, _toDisplayString(_ctx.$t('detailviews.counselingSettings')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvaSetting, (settings, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(settings.description), 1))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getAvaTarget.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("h2", _hoisted_80, _toDisplayString(_ctx.$t('detailviews.counselingTarget')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvaTarget, (tg, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(tg.description), 1))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getAvaTopics.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("h2", _hoisted_84, _toDisplayString(_ctx.$t('detailviews.counselingTopics')) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("ul", _hoisted_86, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvaTopics, (topic, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("div", _hoisted_87, _toDisplayString(topic.description), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_88, [
            _createElementVNode("main", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('detailviews.ccNotFound')), 1)
                  ])
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["state"]))
}